import {
  get,
  post,
  patch,
  del,
} from '@/utils/request';

const url = 'course-tags';

export function index({ is_del, is_disable_count, keyword, page, size }) {
  return get({
    url,
    data: {
      is_del: is_del ? 1 : 0,
      is_disable_count: is_disable_count ? 1 : 0,
      keyword,
      page,
      size,
    },
  });
}

export function getQrCode(id) {
  return patch({
    url: `${url}/${id}/qr-codes`,
  });
}

export function show(id) {
  return get({
    url: `${url}/${id}`,
  });
}

export function store(data) {
  return post({
    url,
    data,
  });
}

export function restore(id) {
  return post({
    url: `${url}/${id}`,
  });
}

export function update(id, data) {
  return patch({
    url: `${url}/${id}`,
    data,
  });
}

export function destroy(id) {
  return del({
    url: `${url}/${id}`,
  });
}
